import { Component } from '@angular/core';

@Component({
  imports: [],
  selector: 'ui-dropdown-popover-layout',
  templateUrl: './dropdown-popover-layout.html',
})
export class DropdownPopoverLayout {}
